// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__72e68","text":"SelectPayment_text__3iabJ","title":"SelectPayment_title__3iLNQ","btn":"SelectPayment_btn__2L3qO"};